import { render, staticRenderFns } from "./ColoniesFilter.vue?vue&type=template&id=44c0bc6f"
import script from "./ColoniesFilter.vue?vue&type=script&lang=ts"
export * from "./ColoniesFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports